import React, { useCallback, useEffect, useRef, useState } from 'react';
import qs from 'qs';
import client, { url } from '../../../lib/api/client';
import DoorSchedule from '../../../components/configuration/door/DoorSchedule';

const DoorScheduleContainer = ({ clubID, socketKey }) => {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [needsReload, setNeedsReload] = useState(false);
  const mounted = useRef(true);
  const busy = useRef(false);
  const endpoint = `${url}/api/door/${clubID}/schedule?${qs.stringify({ socketKey })}`;

  const load = useCallback(async () => {
    if (busy.current) return;
    busy.current = true;
    setLoading(true);
    setError('');
    try {
      const response = await client.get(endpoint);
      if (!response.data || response.data.result !== 1 || !response.data.info) throw new Error((response.data && response.data.message) || '스케쥴을 불러오지 못했습니다.');
      if (mounted.current) {
        // NEEDS_APPLY is explained by the component itself.
        setInfo({ ...response.data.info, requiresApply: response.data.errorCode === 'NEEDS_APPLY' });
        setNeedsReload(false);
      }
    } catch (e) {
      if (mounted.current) {
        setError((e.response && e.response.data && e.response.data.message) || e.message || '스케쥴을 불러오지 못했습니다.');
        setNeedsReload(true);
      }
    } finally { busy.current = false; if (mounted.current) setLoading(false); }
  }, [endpoint]);

  useEffect(() => { mounted.current = true; load(); return () => { mounted.current = false; }; }, [load]);
  const save = async settings => {
    if (busy.current || !info || needsReload) return false;
    busy.current = true;
    setSaving(true);
    setError('');
    try {
      const response = await client.patch(endpoint, { settings, revision: info.revision });
      if (!response.data || response.data.result !== 1 || !response.data.info) throw Object.assign(new Error((response.data && response.data.message) || '스케쥴을 수정하지 못했습니다.'), { code: response.data && response.data.errorCode });
      if (mounted.current) {
        setInfo(response.data.info);
        alert(response.data.info.cleanupPending ? '출입 시간이 저장되었습니다. 이전 설정 정리가 일부 남아 있습니다.' : '출입 시간이 저장되었습니다.');
      }
      return true;
    } catch (e) {
      if (mounted.current) {
        const data = (e.response && e.response.data) || {};
        // CONFLICT is checked before anything is written, so the draft was not applied.
        setError((e.code || data.errorCode) === 'CONFLICT'
          ? '다른 관리자나 다른 컴퓨터에서 출입 시간을 먼저 바꿨어요. 방금 고친 내용은 저장되지 않았어요. ‘최신 내용 불러오기’를 누른 뒤 다시 고쳐서 저장해 주세요.'
          : data.message || e.message || '스케쥴을 수정하지 못했습니다.');
        setNeedsReload(true);
      }
      return false;
    } finally { busy.current = false; if (mounted.current) setSaving(false); }
  };
  return <DoorSchedule info={info} loading={loading} saving={saving} error={error} needsReload={needsReload} onReload={load} onSave={save} />;
};
export default DoorScheduleContainer;
